// @flow
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import { DatePicker } from "@mui/x-date-pickers-pro";
import dayjs from "dayjs";
import React, { useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PageContentWrapper from "../../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../../components/mui/app/pageTitle/pageTitle";
import DataGridWrapper from "../../../components/mui/grids/dataGridWrapper/dataGridWrapper";
import EditableMUIDataGrid from "../../../components/mui/grids/editableMUIDataGrid/editableMUIDataGrid";
import { access_parameters } from "../../../helpers/rights";
import useUserData from "../../../hooks/user/useUserData";
import { withPermissionHOC } from "../../permission/components/permissionHOC/permissionHOC";
import ValidatedDateEditCell from "../components/validatedDateEditCell";
import useCost from "../hooks/useCost";
import { PARAMETERS } from "../locales/namespaces";
//
type Props = {};

const Parameters = (props: Props) => {
	const { t } = useTranslation(PARAMETERS)
	const {UserId} = props;
	const {
		data,
		isLoading,
		refreshGrid,
		total,
		store,
		remove,
		update,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange,
	} = useCost(UserId)

	const {dateFormat} = useUserData()

	const newRowModel = {
		FromDt : dayjs(),
		ToDt : dayjs(),
		WorkCost : '',
		ExtraWorkCost : '',
		UserId:UserId
	}

	const columns = useMemo(() => [
		{
			field: 'FromDt',
			headerName: t('From Date'),
			width: 90, maxWidth: 180, flex: 1,
			editable: true,
			type: 'date',
			valueFormatter: (value) => value ? dayjs(value).format(dateFormat) : null,
			renderEditCell: (params) => (

				<ValidatedDateEditCell
					params={params}
					dateFormat={dateFormat}
					compareField="ToDt"
					direction="before"
					errorMessage="Η ημερομηνία έναρξης πρέπει να είναι πριν ή ίση με την ημερομηνία λήξης."
				/>
			)
		},
		{
			field: 'ToDt',
			headerName: t('To Date'),
			width: 90, maxWidth: 180, flex: 1,
			editable: true,
			type: 'date',
			valueFormatter: (value) => value ? dayjs(value).format(dateFormat) : null,
			renderEditCell: (params) => (
				<ValidatedDateEditCell
					params={params}
					dateFormat={dateFormat}
					compareField="FromDt"
					direction="after"
					errorMessage="Η ημερομηνία λήξης πρέπει να είναι μετά ή ίση με την ημερομηνία έναρξης."
				/>
			)
		},
		{
			field: 'WorkCost',
			headerName: t('Work Cost'),
			width: 150, maxWidth: 300, flex: 1,
			editable: true,
		},
		{
			field: 'ExtraWorkCost',
			headerName: t('Extra Work Cost'),
			width: 90, maxWidth: 180, flex: 1,
			editable: true,
		},

	], [t])
	return (
		<Box className="parameters_index">
			<PageContentWrapper> {/* Wrapper component που δημιουργεί συγκεκριμένο style γύρω από τα grid και τον τίτλο στην index. */}
				{/*<PageTitle*/}
				{/*	title={t('Cost')}/>*/}
				<DataGridWrapper sx={{ height: 600, maxWidth: '700px' }}>
					<EditableMUIDataGrid
						data={data}
						columns={columns}
						loading={isLoading}
						newRowModel={newRowModel}
						store={store}
						remove={remove}
						update={update}
						// hideEditButton={true}
						dataGridProOtherProps={{
							pagination: true,
							paginationModel: { page, pageSize },
							paginationMode: "server",
							onPaginationModelChange: onPaginationModelChange,
							rowCount: Number(total),
							pageSizeOptions: [5, 10, 15, 20, 50, 100],
							sortingMode: "server",
							onSortModelChange: (sortModel) => onSortModelChange(sortModel),
							filterMode: "server",
							onFilterModelChange: onFilterModelChange,
						}}
					/>
				</DataGridWrapper>
			</PageContentWrapper>
		</Box>
	);
};
//
// // export default Parameters
export default withPermissionHOC(Parameters, [access_parameters])